// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let PfixEntitlementSubscriptionHistoryRequestMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_HISTORY_REQ
    PFixMessage.call(this, fieldSet)
}

PfixEntitlementSubscriptionHistoryRequestMessage.prototype = Object.create(PFixMessage.prototype)

PfixEntitlementSubscriptionHistoryRequestMessage.prototype.getFromUtc = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_START_TIME)
}

PfixEntitlementSubscriptionHistoryRequestMessage.prototype.setFromUtc = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_START_TIME, value);
}

PfixEntitlementSubscriptionHistoryRequestMessage.prototype.getToUtc = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_END_TIME)
}

PfixEntitlementSubscriptionHistoryRequestMessage.prototype.setToUtc = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_END_TIME, value);
}